import React from "react";
import ScrollAnimation from "../components/ScrollAnimation";
import "./Products.css";

const Products = () => {
  // Ürün Kategorileri
  const products = [
    {
      id: 1,
      name: "TEK KADEMELİ PİSTONLU KOMPRESÖR",
      image: "/images/products/tek_kademeli.png",
      description:
        "Küçük ve orta ölçekli işletmeler için ideal çözüm. Atölye, oto tamir, boya işleri ve hafif sanayi uygulamalarında yüksek verimlilik ve düşük enerji tüketimi sağlar.",
    },
    {
      id: 2,
      name: "ÇİFT KADEMELİ PİSTONLU KOMPRESÖR",
      image: "/images/products/cift_kademeli.png",
      description:
        "Yüksek basınç gerektiren endüstriyel uygulamalar için profesyonel çözüm. 12 bar basınç kapasitesi ile ağır hizmet tipi işlerde maksimum performans sunar.",
    },
    {
      id: 3,
      name: "BENZİNLİ MOBİL PİSTONLU KOMPRESÖR",
      image: "/images/products/benzinli_mobil_kompresor.png",
      description:
        "Elektrik enerjisine ulaşılamayan alanlarda kullanım için ideal. Şantiyeler ve açık alan çalışmalarında mobil kullanım kolaylığı sağlar.",
    },
    {
      id: 4,
      name: "ALTERNATÖRLÜ MOBİL PİSTONLU KOMPRESÖR",
      image: "/images/products/alternatorlu.jpeg",
      description:
        "Kendi enerjisini üreten alternatörlü sistem ile sürekli enerji kaynağı. Uzun süreli saha çalışmalarında kesintisiz kullanım imkanı sunar.",
    },
    {
      id: 5,
      name: "KAYIŞ KASNAKLI VİDALI KOMPRESÖR",
      image: "/images/products/vidali_kompresor.png",
      description:
        "3kW-75kW güç aralığında ATV serisi vidalı kompresörler. Kayış-kasnaklı tahrik sistemi ile maksimum verimlilik ve düşük enerji tüketimi. IoT destekli dijital kontroller, özel tasarım sessiz kanopi ve separatör tankı ile profesyonel endüstriyel kullanıma ideal.",
    },
    {
      id: 6,
      name: "DEPO ÜSTÜ KAYIŞ KASNAKLI VİDALI KOMPRESÖR",
      image: "/images/products/depo_ustu_vidali.jpeg",
      description:
        "ATV T serisi tank üzerine montajlı kompresörler. Küçük ve orta ölçekli işletmeler için ideal, harici tank gerektirmez. CE sertifikalı 500 litre hava tankı, EN 10028-2 standardında P265GH sınıfı çelikten üretilmiştir. Kayış-kasnaklı tahrik sistemi ve IoT destekli dijital kontroller ile maksimum verimlilik sağlar.",
    },
    {
      id: 7,
      name: "DEPO ÜSTÜ KURUTUCULU KAYIŞ KASNAKLI VİDALI KOMPRESÖR",
      image: "/images/products/depo_ustu_kurutuculu.jpeg",
      description:
        "ATV-TD serisi dahili hava tankı ve kurutucu içeren kompresörler. Basınçlı hava çıkışını 3°C'ye kadar düşürerek kuru ve temiz hava sağlar. CE sertifikalı tank, TMR-MK kurutucu serisi ile maksimum performans. X filtre 1 mikron partikül filtreleme ve 0,01 ppm yağ filtreleme özelliğine sahiptir. Uzun süreli kullanım için ideal.",
    },
    {
      id: 8,
      name: "AKUPLE VİDALI KOMPRESÖR",
      image: "/images/products/akuple_vidali.png",
      description:
        "ATV D serisi 5,5kW-315kW güç aralığında direkt akuple vidalı kompresörler. Elastomer kaplin ile motor ve vida bloğu direkt bağlantı sayesinde minimum enerji kaybı ve maksimum performans. Bakım ihtiyacını minimuma indiren tahrik sistemi. IoT destekli dijital kontroller, özel tasarım sessiz kanopi ve CE sertifikalı separatör tankı ile donatılmıştır.",
    },
    {
      id: 9,
      name: "SÜRÜCÜLÜ KAYIŞ KASNAKLI VİDALI KOMPRESÖR",
      image: "/images/products/suruculu_kayis_kasnakli.png",
      description:
        "Vida bloğu devri hem sürücü hem de kayış-kasnak sistemi ile ayarlanabilir. Elektrik motorunun düşük hızı ayarlanabilen sürücü ile sağlanır. Yumuşak kalkış ve yumuşak duruş özellikleri ile %30-50 arası enerji tüketimi düşüşü, %15-25 enerji tasarrufu sağlar. IoT destekli kontroller, özel tasarım sessiz kanopi ve CE sertifikalı separatör tankı ile donatılmıştır.",
    },
    {
      id: 10,
      name: "DEPO ÜSTÜ SÜRÜCÜLÜ KAYIŞ KASNAKLI VİDALI KOMPRESÖR",
      image: "/images/products/depo_ustu_suruculu.png",
      description:
        "ATV T VS serisi 530 litre CE sertifikalı hava tankı üzerine monte sürücülü elektrik panolu kompresörler. Kompakt yapı ile küçük ve orta ölçekli işletmeler için ideal. Yumuşak kalkış/duruş ve sabit çıkış basıncı özellikleri ile boşta çalışan sürücülü kompresörlerden daha az enerji tüketir. P265GH kaliteli çelik tank ile uzun ömürlü kullanım sağlar.",
    },
    {
      id: 11,
      name: "DEPO ÜSTÜ KURUTUCULU VE SÜRÜCÜLÜ KAYIŞ KASNAKLI VİDALI KOMPRESÖR",
      image: "/images/products/depo_ustu_kurutuculu_suruculu.png",
      description:
        "Dahili hava tankı ve basınçlı hava kurutucusu içeren kompakt modül grubu. TMR-HK kurutucu serisi ile 3°C'ye kadar düşürülmüş kuru hava sağlar. Poly V kayış-kasnak tahrik, sürücülü elektrik panosu ile yumuşak kalkış/duruş ve PID sistemi. X filtre 1 mikron toz, Y filtre 0,01 ppm yağ filtreleme. Tüm ihtiyaçlarınıza kompakt çözüm sunar.",
    },
    {
      id: 12,
      name: "SÜRÜCÜLÜ AKUPLE VİDALI KOMPRESÖR",
      image: "/images/products/suruculu_akuple.png",
      description:
        "ATV D VS serisi 5,5kW-315kW güç aralığında direkt akuple tahrik sistemine ve sürücülü elektrik panosuna sahip kompresörler. Yumuşak yol verme sistemi ile boşta düşük enerji tüketimi ve yüksek verimlilik sağlar. 7-13 Bar çalışma basıncı kapasitesi. Elastomer kaplin ile direkt akuple bağlantı, IoT destekli kontroller ve özel tasarım sessiz kanopi ile profesyonel kullanıma ideal.",
    },
  ];

  return (
    <div className="products-page">
      {/* Products Content */}
      <div className="products-content">
        <div className="container">
          <div className="products-header">
            <h1>Ürünlerimiz</h1>
            <p>
              İhtiyacınıza uygun kompresör çözümlerimizi keşfedin ve fiyat
              teklifi alın.
            </p>
          </div>

          <div className="products-list">
            {products.map((product, index) => (
              <ScrollAnimation
                key={product.id}
                direction="up"
                delay={index * 100}
              >
                <div className="product-card-horizontal">
                  <div className="product-image-container">
                    <img
                      src={product.image}
                      alt={product.name}
                      className="product-image"
                      onError={(e) => {
                        e.target.style.display = "none";
                        e.target.parentElement.style.background = "#f3f4f6";
                        e.target.parentElement.innerHTML = `<div class="product-placeholder"><span class="product-icon">🔧</span></div>`;
                      }}
                    />
                  </div>

                  <div className="product-info">
                    <h3 className="product-name">{product.name}</h3>
                    <p className="product-description">{product.description}</p>
                    <a
                      href={`https://wa.me/905342137564?text=${encodeURIComponent(
                        `Merhaba, ${product.name} hakkında fiyat teklifi almak istiyorum.`
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn  btn-quote"
                    >
                      Fiyat Teklifi Al
                    </a>
                  </div>
                </div>
              </ScrollAnimation>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <section className="products-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Ürünlerimiz Hakkında Detaylı Bilgi</h2>
            <p>
              Size en uygun kompresör modelini seçmek ve teknik özellikler
              hakkında detaylı bilgi almak için bizimle iletişime geçin.
            </p>
            <div className="cta-buttons">
              <a
                href="https://wa.me/905342137564"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary"
              >
                WhatsApp ile İletişim
              </a>
              <a href="tel:+905342137564" className="btn btn-secondary">
                Hemen Arayın
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Products;
